import { Tooltip } from "antd";
import { FolderOpenFilled, ReloadOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';

const Columns = (handleOpenChangeLog, handleReactivateUser) => {
  return [
    {
      title: "Usuario",
      dataIndex: "username",
      key: "username",
      sorter: (a, b) => a.username.localeCompare(b.username),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '35%',
    },
    {
      title: "Nombre",
      dataIndex: "first_name",
      key: "first_name",
      sorter: (a, b) => a.first_name.localeCompare(b.first_name),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Apellido",
      dataIndex: "last_name",
      key: "last_name",
      sorter: (a, b) => a.last_name.localeCompare(b.last_name),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '35%',
    },
    {
      title: "Área",
      dataIndex: "area",
      key: "area",
      render: (area) => area?.name || '-',
      sorter: (a, b) => (a.area?.name || '').localeCompare(b.area?.name || ''),
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Rol Asignado",
      dataIndex: "roles",
      key: "roles",
      render: (_, record) => {
        if (record.is_superuser) {
          return <span style={{ fontWeight: "bold" }}>Superusuario</span>;
        }
        return record.roles?.[0]?.name || "-";
      },
      sorter: (a, b) => {
        const nameA = a.is_superuser ? "Superusuario" : (a.roles?.[0]?.name || "");
        const nameB = b.is_superuser ? "Superusuario" : (b.roles?.[0]?.name || "");
        return nameA.localeCompare(nameB);
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Último Inicio Sesión",
      dataIndex: "last_login_app",
      key: "last_login_app",
      render: (last_login_app) => last_login_app ? dayjs(last_login_app).format('DD/MM/YYYY HH:mm') : '-',
      sorter: (a, b) => {
        const timeA = a.last_login_app ? dayjs(a.last_login_app).valueOf() : 0;
        const timeB = b.last_login_app ? dayjs(b.last_login_app).valueOf() : 0;
        return timeA - timeB;
      },
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '25%',
    },
    {
      title: "Acciones",
      key: "actions",
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      width: '15%',
      render: (_, record) => (
        <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', gap: 12 }}>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
          <Tooltip placement='left' title="Reactivar Usuario">
            <ReloadOutlined
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleReactivateUser(record)}
            />
          </Tooltip>
        </div>
      )
    }
  ];
};

export default Columns;
